// extracted by mini-css-extract-plugin
export default {"container":"DateCarousal_container__xmpAo","date":"DateCarousal_date__G6pFz"};